import styled from "styled-components";
import { colors } from "../../styles/Colors";
import { MainButton, TextBold, TextMedium } from "../../styles/GlobalStyledComponents";

interface ContainerProps {
  $loading?: boolean;
}

export const Container = styled.div<ContainerProps>`
  width: 100%;
  height: 100%;
  display: ${(props) => (props.$loading ? "none" : "flex")} ;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 1 auto;
  gap: 10px;
  margin-top: 8px;
`;

export const Title = styled.span`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: ${colors.gray0};
`;

export const ConditionsWrapper = styled.div`
  width: 100%;
`;

export const SubtitleTextbold = styled(TextBold)`
  font-weight: 700;
`;

export const ConditionsSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: ${colors.gray12};
  width: 100%;
  padding: 8px 12px;
  border-radius: 8px;
  gap: 4px;
  margin-top: 8px;
`;

export const RequestAmount = styled(TextMedium)`

`;

export const OptionsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const OptionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SummaryWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const SummarySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SummaryBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background: ${colors.gray12};
  padding: 9px 13px;
  border-radius: 6px;
`;

export const SummaryRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const SummaryElement = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 3px;
`;

export const TodayHighlight = styled.div`
  background: #00b87a 0% 0% no-repeat padding-box;
  border-radius: 17px;
  padding: 0px 10px;
  margin-right: 4px;
  height: fit-content;
`;

export const TodayHighlightText = styled.span`
  color: white;
  font-weight: 700;
  font-size: 14px;
`;

export const SeparationLine = styled.div`
  margin: 6px 0 10.5px;
  border-top: 1px solid ${colors.separatorColor};
  width: 100%;
  opacity: 0.8;

  @media (max-width: 320px) {
    margin: 2px 0;
  }
`;

export const SummaryDetails = styled.div``;

export const SummaryDetailsInfo = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${colors.gray6};
`;

export const CounterOfferButtonSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: auto;
  padding-bottom: 1rem;
`;

interface CounterOfferButtonProps {
  $secondaryOption?: boolean;
  $greenOption?: boolean;
}

export const CounterOfferButton = styled(MainButton)<CounterOfferButtonProps>`
  font-size: 18px;
  font-weight: 700;
  margin: 0;
background: ${(props) =>
  props.$greenOption
    ? props.disabled
      ? colors.green9
      : colors.green5
    : props.$secondaryOption
    ? colors.white
    : props.disabled
    ? colors.red9
    : colors.red6} 0 0 no-repeat padding-box;
border: ${(props) =>
  props.$greenOption
    ? props.disabled
      ? `2px solid ${colors.green9}`
      : `2px solid ${colors.green5}`
    : props.disabled || !props.$secondaryOption
    ? 'none'
    : `2px solid ${colors.red6}`};
  color: ${(props) => props.$secondaryOption ? colors.red6 : colors.white};
  

  &:hover {
    background: ${(props) =>
      props.$greenOption
        ? props.disabled
          ? colors.green9
          : colors.green5
        : props.$secondaryOption
        ? colors.white
        : props.disabled
        ? colors.red9
        : colors.red6} 0 0 no-repeat padding-box;
    border: ${(props) =>
      props.$greenOption
        ? props.disabled
          ? `2px solid ${colors.green9}`
          : `2px solid ${colors.green5}`
        : props.disabled || !props.$secondaryOption
        ? 'none'
        : `2px solid ${colors.red6}`};
    color: ${(props) => props.$secondaryOption ? colors.red6 : colors.white};
  }
`;